import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import Vant from 'vant';
import { Watermark } from 'vant';

// 完整引入 Vant 样式
import 'vant/lib/index.css';

// 如果需要按需引入组件，可以取消下面的注释并添加需要的组件
// import { Calendar, TimePicker, Swipe, SwipeItem, Grid, GridItem, Cell, CellGroup, Icon } from 'vant';

const app = createApp(App);
app.use(router);
app.use(Vant);
// 如果按需引入，需要单独 use 组件
// app.use(Calendar);
// app.use(TimePicker);
// app.use(Swipe);
// app.use(SwipeItem);
// app.use(Grid);
// app.use(GridItem);
// app.use(Cell);
// app.use(CellGroup);
// app.use(Icon);

app.mount('#app');